import React, { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const skills = [
  // แถวที่ 1: Core Web Dev
  { name: "JavaScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" },
  { name: "TypeScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" },
  { name: "React", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
  { name: "Nextjs", icon: "https://cdn.worldvectorlogo.com/logos/next-js.svg" },
  { name: "TailwindCSS", icon: "https://raw.githubusercontent.com/devicons/devicon/6910f0503efdd315c8f9b858234310c06e04d9c0/icons/tailwindcss/tailwindcss-original.svg" },
  { name: "Node.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
  { name: "Python", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" },
  { name: "PHP", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg" },

  // แถวที่ 2: Database & Web3
  { name: "MongoDB", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" },
  { name: "MySQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" },
  { name: "PostgreSQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" },
  { name: "Redis", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg" },
  { name: "Ethers.js", icon: "https://images.seeklogo.com/logo-png/42/1/ethers-logo-png_seeklogo-426721.png" },
  { name: "Web3.js", icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/web3js/web3js-original.svg" },
  { name: "Solidity", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/solidity/solidity-original.svg" },
  { name: "Puppeteer", icon: "https://www.vectorlogo.zone/logos/pptrdev/pptrdev-icon.svg" },

  // แถวที่ 3: Infra & Automation
  { name: "Cloudflare", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cloudflare/cloudflare-original.svg" },
  { name: "AWS", icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2xQcwKitRgXfqdi34DYlocPSEXD2G2zZipg&s" },
  { name: "Docker", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" },
  { name: "Firebase", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg" },
  { name: "Git", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" },
  { name: "Postman", icon: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg" },
  { name: "Nginx", icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWOoWb2-XM9PsxK940NqKjKKFlmN3Q8zDR0A&s" },
  { name: "Linux", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg" },
  
];

const experiences = [
  {
    role: "Smart Contract Interaction Specialist (Growth & Traffic Operations)",
    company: "Stealth Marketing & Infrastructure Solutions",
    period: "2025 - Present",
    description: [
      "Engineered high-throughput automation systems to accelerate user growth and platform engagement via blockchain interactions.",
      "Developed custom transaction-pushing mechanisms to optimize success rates and minimize processing latency under heavy network load.",
      "Integrated advanced anti-detection and proxy-rotation systems to maintain 24/7 operational continuity and security."
    ]
  },
  {
    role: "Blockchain Infrastructure Engineer",
    company: "Confidential Web3 Startup",
    period: "2024 - Present",
    description: [
      "Architected and developed high-performance interaction layers for DeFi protocols on Layer 1 Blockchains.",
      "Engineered Node.js backend systems to process on-chain data and handle real-time transactions with high efficiency.",
      "Optimized smart contract communication flows to deliver seamless, complex data-driven dashboards."
    ]
  },
  {
    role: "Fullstack Developer (Enterprise Web Applications)",
    company: "Freelance / Software Solutions",
    period: "2022 - Present",
    description: [
      "Designed and deployed scalable full-stack web applications using Next.js, React, and various modern frameworks.",
      "Engineered robust RESTful and GraphQL APIs with Node.js to support high-traffic user requirements and data integrity.",
      "Integrated advanced UI/UX components with GSAP and Tailwind CSS to deliver high-quality, interactive digital experiences."
    ]
  },
 {
    role: "FiveM Developer",
    company: "Pracharak City (Streamer: Fifa Targrean)",
    period: "2021 - 2022",
    description: [
      "Developed and customized FiveM game servers using Lua and JavaScript to create unique gameplay features.",
      "Resolved performance bottlenecks and optimized MySQL databases to support high concurrent user traffic.",
      "Designed automation and monitoring systems to ensure server stability during peak traffic periods."
    ]
  },
  {
    role: "Software Developer",
    company: "Department of Children and Youth (dcy.go.th)",
    period: "2021 - 2021",
    description: [
      "Built internal information management systems focusing on security and data integrity.",
      "Re-designed UI/UX to be modern and intuitive, significantly improving staff productivity and workflow.",
      "Collaborated with the team to establish a scalable system foundation for future requirements."
    ]
  },
  {
    role: "Technical Support & System Administrator",
    company: "P&T Hosting (pathosting.co.th)",
    period: "2020 - 2021",
    description: [
      "Managed Linux server environments (Nginx, Apache) and maintained robust infrastructure security.",
      "Conducted advanced troubleshooting and managed DNS/Networking configurations for enterprise clients.",
      "Provided expert consultation on server optimization tailored to diverse software application needs."
    ]
  },
  {
    role: "Fullstack Developer",
    company: "University Freelance Projects",
    period: "2015 - 2019",
    description: [
      "Developed end-to-end web applications primarily using PHP, HTML, and MySQL.",
      "Delivered tailored digital solutions to meet the business requirements of SMEs.",
      "Cultivated systematic problem-solving skills through diverse client projects during university years."
    ]
  },
];

const About = () => {
  const container = useRef();

 useGSAP(() => {
    // Reveal on Scroll logic
    // Reveal on Scroll logic (แบบเร่งด่วน)
    const sections = gsap.utils.toArray(".reveal");
    sections.forEach((section) => {
      gsap.from(section, {
        scrollTrigger: {
          trigger: section,
          // ปรับจาก "top 95%" เป็น "top 100%" 
          // เพื่อให้เริ่มเล่นทันทีที่ขอบบนของ Element แตะขอบล่างของจอภาพ
          start: "top 100%", 
          toggleActions: "play none none reverse",
        },
        // ลดระยะการเลื่อนจาก 50 เป็น 30 เพื่อให้เข้าที่ไวขึ้น
        y: 30, 
        opacity: 0,
        // ปรับ duration ให้กระชับขึ้น
        duration: 0.4, 
        ease: "power2.out",
        // ป้องกันการสะดุดหาก User ไถเร็วๆ
        overwrite: "auto", 
      });
    });

    // Stagger for Skills
    gsap.from(".skill-item", {
    scrollTrigger: {
      trigger: ".arsenal-title", // ใช้หัวข้อเป็นตัว Trigger แทน
      start: "top 90%", // เริ่มอนิเมชั่นเร็วขึ้นหน่อย
    },
    scale: 0, 
    opacity: 0,
    stagger: 0.05,
    duration: 0.8,
    ease: "back.out(1.7)",
  });
}, { scope: container });

  return (
    <section ref={container} id="about" className="bg-[#f8f9fa] py-24 px-6 md:px-12 overflow-hidden text-slate-900 font-sans">
      
      {/* Title */}
      <div className="reveal text-center mb-20">
        <h1 className="text-6xl font-black uppercase tracking-tighter italic">
          About <span className="text-yellow-500 font-outline-2">Me</span>
        </h1>
        <div className="h-2 w-24 bg-yellow-500 mx-auto mt-4 rounded-full" />
      </div>

      {/* Main Bento Container */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-6">
        
        {/* Intro Card */}
        <div className="reveal md:col-span-8 bg-white p-8 md:p-12 rounded-[2rem] shadow-sm border border-slate-100 flex flex-col md:flex-row gap-10 items-center">
          <div className="relative group flex-shrink-0">
            <video
              src="https://www.dropbox.com/scl/fi/gx8pgsc8upkbyz4hyh7lm/IMG_1216.MOV?rlkey=41d3csgnlxv82udfyab8qf5f0&e=2&st=e301ioe9&raw=1"
              autoPlay muted loop playsInline
              className="w-48 h-48 md:w-64 md:h-64 rounded-3xl object-cover shadow-2xl transition-all duration-500 group-hover:rotate-3 group-hover:scale-105"
            />
            <div className="absolute -bottom-4 -right-4 bg-yellow-500 p-4 rounded-2xl font-black text-white shadow-lg">
              DEV
            </div>
          </div>
          <div className="flex-1 space-y-4 text-left">
            <h2 className="text-3xl font-bold">
              Hi, I'm <span className="text-yellow-500 underline decoration-4 underline-offset-8">Justin</span>
            </h2>
            <p className="text-xl text-slate-600 font-medium leading-relaxed">
              A Fullstack & Software Developer Who Loves Climbing. I focus on developing practical and efficient software solutions.
            </p>
            <p className="text-slate-500">
              With a strong interest in problem-solving and innovation, I strive to create meaningful and user-friendly digital experiences.
            </p>
          </div>
        </div>

        {/* Small Stat Card */}
        <div className="reveal md:col-span-4 bg-slate-900 text-white p-8 rounded-[2rem] flex flex-col justify-center items-center text-center relative overflow-hidden group">
          <div className="absolute top-0 right-0 p-10 opacity-10 group-hover:scale-150 transition-transform duration-700">
             <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" className="w-32 h-32" alt="bg" />
          </div>
          <h3 className="text-5xl font-black text-yellow-500">5+</h3>
          <p className="text-slate-400 font-bold uppercase tracking-widest mt-2">Years of Exp</p>
        </div>

                {/* Skills Section Title - เพิ่ม Class arsenal-title */}
        <div className="reveal arsenal-title md:col-span-12 mt-12 mb-6">
           <h2 className="text-4xl font-bold italic tracking-tight">
             Technical <span className="text-yellow-500">Arsenal</span>
           </h2>
        </div>

        {/* Skills Grid - มั่นใจว่ามี Class skill-item ที่ลูกทุกตัว */}
        <div className="md:col-span-12 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4">
          {skills.map((skill, index) => (
            <div key={index} className="skill-item bg-white p-6 rounded-3xl border border-slate-100 shadow-sm flex flex-col items-center justify-center">
              <div className="w-12 h-12 mb-3">
                <img src={skill.icon} alt={skill.name} className="w-full h-full object-contain" />
              </div>
              <span className="text-[10px] font-black uppercase text-slate-400 tracking-tighter">
                {skill.name}
              </span>
            </div>
          ))}
        </div>

        {/* Experience Section */}
        <div className="md:col-span-12 mt-20">
          <h2 className="reveal text-4xl font-bold italic mb-12 text-left">Professional <span className="text-yellow-500">Journey</span></h2>
          <div className="space-y-6">
            {experiences.map((exp, index) => (
              <div key={index} className="reveal group flex flex-col md:flex-row gap-6 bg-white p-8 rounded-[2rem] border border-slate-100 hover:shadow-2xl hover:border-yellow-500 transition-all duration-500">
                <div className="md:w-1/4 text-left">
                   <span className="bg-slate-100 px-4 py-2 rounded-full text-sm font-bold text-slate-500 group-hover:bg-yellow-500 group-hover:text-white transition-colors italic">
                     {exp.period}
                   </span>
                </div>
                <div className="md:w-3/4 text-left">
                  <h3 className="text-2xl font-black text-slate-900">{exp.role}</h3>
                  <p className="text-yellow-600 font-bold mb-4">{exp.company}</p>
                  <ul className="list-disc list-inside text-slate-500 space-y-2 leading-relaxed">
                    {exp.description.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;